<template>
    <label class="label justify-start p-0 text-base xs:text-lg w-fit">
        <input
            :value="value"
            type="radio"
            :name="name"
            :disabled="disabled"
            :checked="checked"
            class="radio"
            :class="[radioType==='1'?'formed-radio':'radio-blue-center']"
            @input="$emit('update:checkedValue',$event.target.value)"
        >
        <slot>
            <span :class="[{'text-gray-100':disabled},textClass?textClass:'']">
                {{ text }}
            </span>
        </slot>
    </label>
</template>

<script>
import { toRefs, computed } from 'vue';
export default {
    props: {
        text: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [String, Boolean, Number],
            required: true,
        },
        checkedValue: {
            type: [String, Boolean, Number],
            required: true,
        },
        name: {
            type: String,
            default: '',
        },
        textClass: {
            type: String,
            default: ''
        },
        radioType: {
            type: String,
            default: '1', // radio-blue-center
        },
    },
    emits: ['update:checkedValue'],
    setup(props, { emit }) {
        const { checkedValue, value } = toRefs(props);
        const checked = computed(() => {
            let isTrue = false;
            if (typeof checkedValue.value === 'string') isTrue = checkedValue.value === value.value;
            if (typeof checkedValue.value === 'boolean') isTrue = checkedValue.value;
            if (typeof checkedValue.value === 'number') isTrue = checkedValue.value.toString() === value.value;
            return isTrue;
        });
        return { checked };
    }
};
</script>
<style scoped>
.label {
    /* w-fit沒有效 */
    width: fit-content;
}
.radio {
    @apply w-[0.8125rem] h-[0.8125rem] md:w-[0.9375rem] md:h-[0.9375rem] border border-gray-200 mr-2;
}
.radio-blue-center {
    @apply w-[0.8125rem] h-[0.8125rem] bg-white checked:bg-primary checked:border-0 disabled:bg-gray-200 disabled:border-gray-200;
    box-shadow: 0 0 0 3px hsl(var(--b1)) inset, 0 0 0 3px hsl(var(--b1)) inset;
}
.formed-radio {
    @apply bg-white checked:bg-white checked:border-primary checked:border-4 checked:md:border-[0.3125rem] disabled:bg-gray-200 disabled:border-gray-200 translate-y-px transition duration-150;
}
</style>
